import { useMemo } from 'react';
import { Text, Icon, CollapseItem } from '@weareconceptstudio/core';

//* Style
import FaqItemStyle from './style';

//* Components
import Editor from '@/components/Editor';

const FaqItem = ({ data }) => {
	const itemData = useMemo(() => {
		return (
			<div className='wrapper-all-title-wrapper'>
				{data.faqs.map((el, i) => {
					const index = `${data.name}-${i}`;

					return (
						<div
							key={index}
							className='title-answer-wrapper'>
							<CollapseItem
								title={
									<div className='wrapper-ask'>
										<Text className={'p3 ask-text'}>{el.question}</Text>
										<Icon
											name={'left-arrow'}
											className={`icon-${index} collapse-icon`}
										/>
									</div>
								}
								description={
									<div className={`answer-wrapper answer-wrapper-${index}`}>
										<Editor
											className={'answer-text faq-version'}
											data={el.answer}
										/>
									</div>
								}
							/>
						</div>
					);
				})}
			</div>
		);
	}, []);

	return (
		<FaqItemStyle>
			<div className='wrapper-categories-title'>
				<Text className={'p p2 font-montserrat-arm-medium first-letter'}>{data.name}</Text>
				{itemData}
			</div>
		</FaqItemStyle>
	);
};

export default FaqItem;
